import { IReadKeyParams } from "@prostocheck/data-web";
import { CA_AUTO_DETECT_VALUE } from "@prostocheck/shared";

import { LoginStepEnum, ILoginStepDef } from "./login.models";

/** Container formats `libs/kep` can read — see ai/docs/kep-signing.md. */
export const KEY_FILE_ACCEPT = ".dat,.pfx,.pk8,.zs2,.jks";

export const LOGIN_STEPS: ILoginStepDef[] = [
  { step: LoginStepEnum.Key, titleKey: "login.steps.key" },
  { step: LoginStepEnum.SignIn, titleKey: "login.steps.signIn" },
];

/**
 * The form collects exactly what `readKey` takes, plus the fields it is bound
 * to on screen. Defaults to auto-detect: most users do not know which ЦСК
 * issued their key, and picking one wrong only turns into "certificates not
 * found" a step later.
 */
export const INITIAL_KEY_FORM_VALUES: IReadKeyParams = {
  file: null,
  password: "",
  cmpUrl: CA_AUTO_DETECT_VALUE,
};
